import script from "./Reports.vue?vue&type=script&lang=ts&setup=true"
export * from "./Reports.vue?vue&type=script&lang=ts&setup=true"

import "./Reports.vue?vue&type=style&index=0&id=acce60ac&lang=css"

const __exports__ = script;

export default __exports__